import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class CorporateSiteService {
    async getCorporateSiteByEvoEnvironmentName(evoEnvironmentName: string): Promise<any> {
        let url = `${process.env.REACT_APP_SELF_SERVICE_CARECOMPLIANCE_API_URL}/CorporateSite/evo/${evoEnvironmentName}`;
        let response = await getAuthenticatedFetch()(url);
        return response.text();
    }
}

export default new CorporateSiteService();
